// extracted by mini-css-extract-plugin
export default {"isBoxed":"Payment_isBoxed__xBSkv","subPrice":"Payment_subPrice__Ui9TR","payment_area":"Payment_payment_area__uxySr","divider":"Payment_divider__8seVV"};